export const GIT_HASH = '8683baf02';
